
document.addEventListener('DOMContentLoaded', function () {

  
  // Initialize Splide
  const splide = new Splide('#transformationSplide', {
    type: 'loop',
    perPage: 1,
    perMove: 1,
    pagination: true,
    arrows: true,
    noDrag: '.no-drag',
    updateOnMove: true,
    autoplay: false,

    breakpoints: {
      767: {
        perPage: 1,
        perMove: 1,
        arrows: true,
        pagination: true,
      },
    },
  });

  // Mount the carousel
  splide.mount();

  //attach events to custom buttons
  wfbtnNext.addEventListener('click', e => {
    splide.go('+1')
  })

  wfbtnPrev.addEventListener('click', e => {
    splide.go('-1')
  })
});